<div class="d-flex justify-content-between">
  <label class="container" (click)="radioClick.emit(value)">
    <input type="radio" name="radio" [checked]="checked" />
    <span class="checkmark"></span>
    <h5 class="ml-4 font-weight-bold">{{ text }}</h5>
  </label>
  <img class="item-img pointer" *ngIf="img" [src]="img" (click)="imgClick.emit($event)" />
</div>
